import type { components } from '@connected/api-client/api.generated';

export const OBSERVATION_COLOR_CODES = {
    Remark: '#1BC0F4',
    Severe: '#DF3C32',
    Serious: '#F4841B',
    Minor: '#E4CE0E',
    null: null,
} as const;

export const DISTRIBUTION_BOARDS_OBSERVATION_KINDS = [
    'DistributionBoard',
    'DistributionBoardInformation',
    'DistributionBoardMeasurements',
    'DistributionBoardNetImpedance',
    'DistributionBoardCircuitImpedance',
    'DistributionBoardCurrent',
    'DistributionBoardGeneralInformation',
    'DistributionBoardImages',
    'DistributionBoardThermalImages',
    'DistributionBoardVoltage',
] as const satisfies components['schemas']['ElectricalProjectObservationObjectKind'][];

export const FINAL_CIRCUITS_OBSERVATION_KINDS = [
    'FinalCircuit',
    'FinalCircuitImages',
    'FinalCircuitThermalImages',
] as const satisfies components['schemas']['ElectricalProjectObservationObjectKind'][];
